import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
  }
  html, body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: ${calculateResponsiveSize(14)};
    color: #ffffff;
    line-height: 1.25;
    background: #2E1619;
    min-width: 320px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    scrollbar-color: #FAF8F5 #2E1619;
    &::-webkit-scrollbar-track {
      background: #2E1619;
    }
    &::-webkit-scrollbar-thumb {
      background: #FAF8F5;
    }
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(14)};
    }
    color-scheme: dark;
  }
  body{
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  ${mediaMax('mobile')} {
    html, body {
      height: 100svh;
      overflow: hidden;
    }
  }
  body.hidden {
    height: 100dvh !important;
  }
  ${mediaMax('mobile')} {
    body.hidden {
      overflow: hidden;
    }
  }
  body.hidden .wrapper {
    height: 100dvh;
    overflow: hidden;
  }
  html, body, A, input, select, textarea, button{
    font-family: 'Proxima Nova', Arial, Tahoma, Geneva, Kalimati, sans-serif;
  }
  A{
    text-decoration: none;
    color: #ffffff;
    outline: none;
  }
  A:hover{
    text-decoration: underline;
  }
  input, select, textarea {
    vertical-align: top;
    outline: none;
  }
  /* ----- Safari profile icon ----- */
  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  textarea {
    resize: vertical;
  }
  *{ -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
  img, object, iframe, svg{ border: 0; vertical-align: top; }
  button { font-weight: 400; }
  /* ----- react-select ----- */
  @keyframes selectSlideInOut {
    0% {
      transform: translateY(-1px);
    }
    100% {
      transform: translateY(0);
    }
  }

  /* ----- For br ----- */
  .for-mobile {
    display: none;
  }
  ${mediaMax('mobile')} {
    .for-desktop {
      display: none;
    }
    .for-mobile {
      display: inline;
    }
  }

  /* ----- UserWay ----- */
  body .uwy > .userway_buttons_wrapper  {
    top: auto !important;
    bottom: ${calculateResponsiveSize(30)} !important;
    left: ${calculateResponsiveSize(40)} !important;
    right: auto !important;
    transform: none !important;
  }
  body .uwy .uai, body .uwy .uai > span {
    width: ${calculateResponsiveSize(40)} !important;
    height: ${calculateResponsiveSize(40)} !important;
  }
  body .uwy .uai > span > img {
    width: 100% !important;
    height: auto !important;
  }
  ${mediaMax('mobile')} {
    body .uwy > .userway_buttons_wrapper  {
      bottom: ${calculateMobileResponsiveSize(26)} !important;
      left: ${calculateMobileResponsiveSize(20)} !important;
    }
    body .uwy .uai, body .uwy .uai > span {
      width: ${calculateMobileResponsiveSize(40)} !important;
      height: ${calculateMobileResponsiveSize(40)} !important;
    }
  }
`

export default GlobalStyle
